<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
    <template #parameters="{ getSecret, setSecret, getParam, setParam }">
      <div class="box">
        <h2 class="subtitle">{{ $t('ifttt.settings') }}</h2>

        <BFieldHint :label="$t('ifttt.eventName')" hintKey="">
          <b-input
            :model-value="getParam('IFTTT_EVENT_NAME')"
            :placeholder="$t('ifttt.eventNamePlaceholder')"
            @update:model-value="val => setParam('IFTTT_EVENT_NAME', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('ifttt.apiKey')" hintKey="">
          <b-select :model-value="getSecret('IFTTT_KEY')"
                    :placeholder="$t('ifttt.selectSecret')"
                    @update:model-value="val => setSecret('IFTTT_KEY', String(val))">
            <option v-for="name in secretOptions" :key="name" :value="name">{{ name }}</option>
          </b-select>
        </BFieldHint>
      </div>
    </template>
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import BFieldHint from '@/components/BFieldHint.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'IFTTTForm',
  components: { WebhookForm, BFieldHint },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const store = useStore()
    const secretOptions = computed<string[]>(() => {
      const s: any = store.state.secrets || []
      const list = Array.isArray(s) ? s : Object.values(s)
      return list.map((x: any) => String(x.name)).filter(Boolean)
    })

    const defaultInitial = {
      name: '',
      event: 'ifttt-trigger',
      template: 'ifttt',
      url: 'https://maker.ifttt.com/trigger/{{{IFTTT_EVENT_NAME}}}/with/key/{{{IFTTT_KEY}}}',
      requestType: 'POST',
      noDefaults: false,
      rejectUnauthorized: true,
      unchunked: false,
      data_url_response_event: false,
      json: {}
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: false,
      requestType: false,
      requestFormat: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { secretOptions, effectiveInitial, visibilityConfig }
  }
})
</script>
